import React from 'react';

const Uganda_p6math_elements = () => {
  return (
    <div>
      
    </div>
  );
}

export default Uganda_p6math_elements;
